import CollapseItem from '../collapse/src/collapse-item.vue';

CollapseItem.install = function(Vue) {
  Vue.component(CollapseItem.name, CollapseItem);
};

export default CollapseItem;



// WEBPACK FOOTER //
// ./src/components/collapse-item/index.js